import React, { useEffect, useRef } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Line } from 'react-chartjs-2';

// Register ChartJS components
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const ChartComponent = ({ data, options }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        // Update chart when data changes
        if (chartRef.current) {
            chartRef.current.update();
        }
    }, [data]);

    return (
        <div style={{ width: '100%', height: '400px', position: 'relative' }}>
            <Line
                ref={chartRef}
                data={data}
                options={{
                    ...options,
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        ...options?.plugins
                    },
                }}
            />
        </div>
    );
};

export default ChartComponent;